import api from "@modules/api/api";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import consumerFinancingQueryKeys from "../consumerFinancingQueryKeys";
import { CreditScoreBand } from "../types/CreditScoreBand";

const getCreditBands = async (): Promise<CreditScoreBand[]> => {
  return api.get<CreditScoreBand[]>(
    "api/purchases/c2c-financing/credit-score-bands"
  );
};

export default function useGetCreditBands() {
  const { data, error, refetch } = useQuery({
    queryKey:
      consumerFinancingQueryKeys.consumerFinancingCalculatorCreditScoreBands(),
    queryFn: getCreditBands,
  });

  return {
    bands: useMemo(() => data ?? [], [data]),
    isLoading: !error && !data,
    error,
    refetch,
  };
}
